
import { toastSucesso } from './utilidades/toastSucesso';
import { toastErroCarregar } from './utilidades/toastErroCarregar';
import { getFetch } from './utilidades/getFetch';
import { postFetch } from './utilidades/postFetch';
import { obterQueryString } from './utilidades/obterQueryString';
import { obterOrigem } from './utilidades/obterOrigem';
import { obterDispositivo } from './utilidades/obterDispositivo';
import { loadFullPage } from './utilidades/loadFullPage';
import { obterCookie } from './utilidades/obterCookie';
import { isNullOrEmpty } from './utilidades/isNullOrEmpty';
import { salvarCookie } from './utilidades/salvarCookie';
import { inicializarInternacionalizacao } from './localizacao/vagas-detalhes/vagas-detalhes';
import { addTrack } from './utilidades/trackEventos';
import { salvarCandidaturaPendente, removerCandidaturaPendente } from './utilidades/candidaturaPendente';

import { Confirm } from 'notiflix/build/notiflix-confirm-aio';
import { Report } from 'notiflix/build/notiflix-report-aio';
import { AlertaVaga } from './utilidades/alertaVaga';
import { templateCardAlertaVagas } from './componentes/alertaVagas/templatesAlertaVaga';

import i18next from 'i18next';

import { localBanner, banner } from './utilidades/banner'


const vagaDetalhes = function () {

    const nomeEmpresa = document.getElementById("nomeEmpresa").value;
    const vagaID = document.getElementById('VagaID').value;
    const vagaTitulo = document.getElementById('VagaTitulo').value;
    const vagaCidadesSeparadas = document.getElementById('VagaCidadesSeparadas').value;
    const vagaCidadesSeparadasVirgula = document.getElementById('VagaCidadesSeparadasVirgula').value;
    const vagaCargo = document.getElementById('VagaCargo').value;
    const vagaUrl = document.getElementById('VagaURL').value;
    const variasCidades = document.getElementById('VariasCidades') ? document.getElementById('VariasCidades').value == 'True' : 'False';
    const $containerInscrevase = document.getElementById('container-candidatar');
    //const $containerInscrevaseRodape = document.getElementById('container-candidatar-rodape');
    const $containerInscrevaseStick = document.getElementById('container-candidatar-stick');

    const _modalCompartilharCopiarLink = function () {
        const textoLinkVaga = document.querySelector('.texto-link-vaga');
        const btnCopiarLinkVaga = document.querySelector('.btn-copiar-link-vaga');

        function _copiarLink() {
            navigator.clipboard
                .writeText(textoLinkVaga.innerText)
                .then(() => {
                    toastSucesso(i18next.t('ModalCompartilharLinkVagaCopiado'));
                })
                .catch(() => {
                    toastErroCarregar(i18next.t('ModalCompartilharErroCopiarLink'));
                });
        }
        btnCopiarLinkVaga.addEventListener('click', () => _copiarLink());
        textoLinkVaga.addEventListener('click', () => _copiarLink());
    };
    const _modalCompartilhar = function () {

        if (navigator.share && obterDispositivo() != "Desktop") {
            navigator.share({
                title: `Empregare.com - ${document.getElementById('VagaTitulo').value}`,
                url: vagaUrl
            }).then(() => {

            }).catch((erro) => {
                console.log('Erro navigator share: ');
                console.log(erro);
            });


        } else {
            const $modalCompartilhar = new bootstrap.Modal(document.getElementById('modalDivulgacao'), {});
            $modalCompartilhar.show();


        }
        addTrack('Compartilhar Vaga', { vagaID: vagaID });

    };
    const _modalSelecaoCega = function (tab) {
        document.querySelector('#tabsInfoSelecaoCega button[data-bs-target="' + tab + '"]').dispatchEvent(new Event('click'));
    };
    const _modalCandidatarLogin = function () {
        const $modalCandidatar = bootstrap.Modal.getInstance(document.getElementById('modal-candidatar'));
        $modalCandidatar.hide();

        document.querySelector('.btn-login').click();

        //document.getElementById('load-form-login').classList.remove('d-none');
        //document.getElementById('box-mostrar-login').classList.add('d-none');
    };

    const _insights = async function (pessoaID) {

        if (obterQueryString().confirmar === '1') {
            return;
        }
        let formData = new FormData();
        formData.append('vagaID', vagaID);
        formData.append('origem', obterOrigem());
        formData.append('pessoaID', pessoaID);
        formData.append('url', window.location.hostname);
        formData.append('dispositivo', obterDispositivo());

        await fetch(`/${CULTURE_EMPREGARE}/Vagas/SalvarVisualizacao`, {
            method: 'POST',
            body: formData
        });

        addTrack('Visualizar Vaga', { vagaID: vagaID, referer: obterOrigem(), origem: obterCookie('origemCadastro') });
    };

    const _cancelarCandidatura = async function (candidaturaID) {
        loadFullPage.mostrar();

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            Report.success(
                i18next.t('CancelarCandidaturaSucesso'),
                '',
                i18next.t('ReportOk'),
                () => {
                    loadFullPage.mostrar();
                    window.location.reload();
                }
            );

        }
        const callbackErro = (resultado) => {
            loadFullPage.esconder();
        }

        let formData = new FormData();
        formData.append('id', candidaturaID);

        await postFetch(`/${CULTURE_EMPREGARE}/PainelCandidaturas/CancelarCandidatura`, formData, callbackSucesso, callbackErro, callbackErro);
    };
    const _confirmarCandidatura = async function () {
        loadFullPage.mostrar();
        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();


            if (resultado.id > 0) {
                addTrack('Inscricao Vaga', { finalizouCandidatura: true, vagaID: vagaID });

                removerCandidaturaPendente(false);

                const $modalConfirmarCandidatura = bootstrap.Modal.getInstance(document.getElementById('modal-confirmar-candidatura'));

                if ($modalConfirmarCandidatura) {
                    $modalConfirmarCandidatura.hide();
                }


                if (resultado.questionario) {
                    Report.success(
                        i18next.t('ConfirmarCandidaturaSucesso'),
                        i18next.t('ConfirmarCandidaturaQuestionario'),
                        i18next.t('ConfirmarCandidaturaResponderQuestionario'),
                        () => {
                            loadFullPage.mostrar();
                            window.location.href = `/${CULTURE_EMPREGARE}/candidato/questionarios/${vagaID}_${resultado.id}?inscricao=${vagaID}`;
                        }
                    );
                } else {

                    _botaoCandidatar();

                    Report.success(
                        i18next.t('ConfirmarCandidaturaSucesso'),
                        i18next.t('ConfirmarCandidaturaInscricaoRealizada'),
                        i18next.t('ReportOk'),
                        () => {

                        }
                    );
                    //Confirm.init({
                    //    className: "confirm-empregare",
                    //    titleColor: "#018100",
                    //    okButtonColor: "#ffffff",
                    //    width: '350px',
                    //    okButtonBackground: "#018100",                       
                    //    cancelButtonColor: "#f8f8f8",
                    //});
                    //Confirm.show(
                    //    i18next.t('ConfirmarCandidaturaSucesso'),
                    //    i18next.t('ConfirmarCandidaturaInscricaoRealizada'),
                    //    i18next.t('ConfirmarCandidaturaRevisarCurriculo'),
                    //    i18next.t('ConfirmarCandidaturaVisualizarCandidatura'),
                    //    () => {
                    //        loadFullPage.mostrar();
                    //        window.location.href = `/${CULTURE_EMPREGARE}/candidato/curriculo?inscricao=${vagaID}`;
                    //    },
                    //    () => {
                    //        loadFullPage.mostrar();
                    //        window.location.href = `/${CULTURE_EMPREGARE}/candidato/inscricao_${resultado.id}?inscricao=${resultado.vagaID}`;
                    //    },
                    //    {},
                    //);
                }

            } else {
                if (resultado.retorno === 'CidadeNaoSelecionada') {
                    Report.warning(
                        i18next.t('CidadeNaoSelecionadaAtencao'),
                        resultado.retornoMensagem,
                        i18next.t('ReportOk'),
                    );
                } else {
                    const $modalConfirmarCandidatura = bootstrap.Modal.getInstance(document.getElementById('modal-confirmar-candidatura'));
                    if ($modalConfirmarCandidatura) {
                        $modalConfirmarCandidatura.hide();
                    }
                    _montaBotaoCandidatar(resultado);
                }
            }
        }
        const callbackErro = (resultado) => {
            loadFullPage.esconder();
        }

        const source = obterCookie('origemCadastro');
        const origem = obterOrigem();
        const dispositivo = obterDispositivo();

        let formData = new FormData(document.getElementById('form-confirmar-inscricao'));
        formData.append('id', vagaID);
        formData.append('source', source);
        formData.append('referer', origem);
        formData.append('dispositivo', dispositivo);

        await postFetch(`/${CULTURE_EMPREGARE}/Vagas/ConfirmarCandidatura`, formData, callbackSucesso, callbackErro, callbackErro);

    };
    const _redirecionarNovoCadastro = function () {
        loadFullPage.mostrar();
        window.location.href = `/${CULTURE_EMPREGARE}/cadastrar-curriculo`;

    };

    const _montaBotaoCandidatar = (resultado) => {
        let gatilho = '';
        let botaoCandidatarHtml = '';
        if (!isNullOrEmpty(resultado.gatilho.titulo)) {
            gatilho = `<small class="gatilho-mental p-3 text-muted">${resultado.gatilho.icone} ${resultado.gatilho.titulo}</small>`;
        }

     


        switch (resultado.retorno) {
            case "VagaEncerrada":
                $containerInscrevase.innerHTML = `<div class="alert alert-danger mb-0">
                        <h5>${i18next.t('VagaEncerradaNaoRecebeCurriculos')}</h5>
                        <p class="mt-3 mb-0">${i18next.t('VagaEncerradaPossiveisMotivos')}</p>
                        <ul class="mb-0">
                            <li>${i18next.t('VagaEncerradaFechadaOuEncerrada')}</li>
                            <li>${i18next.t('VagaEncerradaAtingiuDataExpiracao')}</li>
                            <li>${i18next.t('VagaEncerradaVagaCancelada')}</li>
                        </ul>
                    </div>`;
                const btnModalCompartilhar = document.querySelectorAll('.btn-abrir-modal-divulgacao');
                btnModalCompartilhar.forEach(el => el.classList.add('d-none'));

                removerCandidaturaPendente(false);
                document.getElementById('VagaStatus').value = resultado.retorno;
                return;
            case "NaoLogado":

                botaoCandidatarHtml = `<button type="button" title="${i18next.t('BotaoCandidatarSeVaga')}" class="btn btn-primary btn-fullwidth-mobile btn-candidatarse"><i class="bi bi-clipboard-check"></i> ${i18next.t('BotaoCandidatarSe')}</button>${gatilho}`;
                $containerInscrevase.innerHTML = botaoCandidatarHtml;
                // $containerInscrevaseRodape.querySelector('#container-candidatar-rodape-btn').innerHTML = botaoCandidatarHtml;
                //  $containerInscrevaseRodape.classList.remove('d-none');

                const btnCandidatar = document.querySelectorAll('.btn-candidatarse');

                btnCandidatar.forEach(el => el.addEventListener('click', () => {
                    document.querySelector('.btn-login').click();
                    addTrack('Inscricao Vaga', { finalizouCandidatura: false, vagaID: vagaID });
                    salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, false);
                }));

                _stickyTopScrollDetalhesVaga($containerInscrevase, $containerInscrevaseStick, 'NaoLogado');
                return;
            case "CurriculoIncompleto":
                $containerInscrevase.innerHTML = `<div class="alert alert-warning mb-0">
                        <h5>${i18next.t('CurriculoIncompleto')}</h5>
                        <p class="mb-1">${i18next.t('CurriculoIncompletoTexto')}</p>
                        <p class="mb-1">${i18next.t('CurriculoIncompletoEfetueMudancas')}</p>
                        <button type="button" class="btn btn-warning text-light btn-curriculo-incompleto"><i class="bi bi-file-earmark-text" aria-hidden="true"></i> ${i18next.t('CurriculoIncompletoBotao')}</button>
                    </div>`;
                if ($containerInscrevase.querySelector('.btn-curriculo-incompleto') != undefined) {
                    $containerInscrevase.querySelector('.btn-curriculo-incompleto').addEventListener('click', async (e) => {
                        loadFullPage.mostrar();
                        await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
                        window.location.href = `/${CULTURE_EMPREGARE}/candidato/curriculo-incompleto`;
                    });
                }
                return;
            case "CurriculoNaoPermitido":
            case "CurriculoNaoExiste":
            case "LimiteUltrapassado":
            case "SomenteColaboradores":
            case "SomenteCandidatos":
            case "DeficienciaObrigatoria":
            case "AlunoNaoEncontrado":
            case "AlunoExAluno":

                var mensagem = resultado.retornoMensagem;
                if (nomeEmpresa) {
                    mensagem = mensagem.replace("##nomeEmpresa##", nomeEmpresa);
                } else {
                    // Se o ##nomeEmpresa## n�o existir, fazer a substitui��o por uma string vazia
                    mensagem = mensagem.replace("##nomeEmpresa##", "");
                }
                $containerInscrevase.innerHTML = `<div class="alert alert-warning mb-0">
                        <h5><i class="bi bi-exclamation-circle"></i> ${i18next.t('AlunoCandidaturaBloqueada')}</h5>
                        <p>${mensagem}</p>
                    </div>`;

                removerCandidaturaPendente(false);
                document.getElementById('VagaStatus').value = resultado.retorno;
                return;
            case "Inscrito":
                $containerInscrevase.innerHTML = `
                        <div class="row"><div class="col-12 text-center"><p class="mb-3"><b class="text-success"><i class="bi bi-check2-circle"></i> ${i18next.t('InscritoJaCandidatado')}</b><p>
                        
                        <a href="/${CULTURE_EMPREGARE}/candidato/inscricao_${resultado.id}" class="btn btn-primary mb-3 btn-fullwidth-mobile">${i18next.t('ConfirmarCandidaturaVisualizarCandidatura')}</a>
                        <button type="button" class="btn btn-outline-danger btn-cancelar mb-3 btn-fullwidth-mobile" data-id="${resultado.id}">${i18next.t('CancelarCandidatura')}</button>
                </div>`;

                $containerInscrevase.querySelector('.btn-cancelar').addEventListener('click', (e) => {
                    const candidturaID = e.target.getAttribute('data-id');
                    Confirm.show(
                        i18next.t('CancelarCandidatura'),
                        i18next.t('CancelarCandidaturaTexto'),
                        i18next.t('CancelarCandidaturaConfirmar'),
                        i18next.t('CancelarCandidaturaCancelar'),
                        () => {

                            _cancelarCandidatura(candidturaID);
                        },
                        () => { },
                        {},
                    );
                });

                removerCandidaturaPendente(false);
                document.getElementById('VagaStatus').value = resultado.retorno;
                return;
            case "Liberado":
            case "Cancelado":



                if (obterQueryString().confirmar == '1') {
                    const $modalConfirmarCandidatura = new bootstrap.Modal(document.getElementById('modal-confirmar-candidatura'), {});
                    $modalConfirmarCandidatura.show();
                }
                if (variasCidades) {

                    botaoCandidatarHtml = `<button type="button" title="${i18next.t('BotaoCandidatarSeVaga')}" class="btn btn-primary btn-fullwidth-mobile btn-candidatarse" data-bs-target="#modal-confirmar-candidatura" data-bs-toggle="modal"><i class="bi bi-clipboard-check"></i> ${i18next.t('BotaoCandidatarSe')}</button>${gatilho}`;
                    $containerInscrevase.innerHTML = botaoCandidatarHtml;
                    // $containerInscrevaseRodape.querySelector('#container-candidatar-rodape-btn').innerHTML = botaoCandidatarHtml;
                    // $containerInscrevaseRodape.classList.remove('d-none');

                    const btnCandidatar = document.querySelectorAll('.btn-candidatarse');

                    btnCandidatar.forEach(el => el.addEventListener('click', async () => {
                        await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
                        addTrack('Inscricao Vaga', { finalizouCandidatura: false, vagaID: vagaID });
                    }));

                } else {
                    botaoCandidatarHtml = `<button type="button" title="${i18next.t('BotaoCandidatarSeVaga')}" class="btn btn-primary btn-fullwidth-mobile btn-candidatarse"><i class="bi bi-clipboard-check"></i> ${i18next.t('BotaoCandidatarSe')}</button>${gatilho}`;
                    $containerInscrevase.innerHTML = botaoCandidatarHtml;
                    //  $containerInscrevaseRodape.querySelector('#container-candidatar-rodape-btn').innerHTML = botaoCandidatarHtml;
                    //  $containerInscrevaseRodape.classList.remove('d-none');

                    const btnCandidatar = document.querySelectorAll('.btn-candidatarse');

                    btnCandidatar.forEach(el => el.addEventListener('click', async () => {
                        _confirmarCandidatura();
                    }));
                }
                _stickyTopScrollDetalhesVaga($containerInscrevase, $containerInscrevaseStick, 'Logado');
                return;
            case "AlunoSemMatricula":
                $containerInscrevase.innerHTML = `<div class="alert alert-warning mb-0">
                        <h5><i class="bi bi-exclamation-circle"></i> ${i18next.t('AlunoCandidaturaBloqueada')}</h5>
                        <p class="mb-1">${resultado.retornoMensagem}</p>
                        <a class="btn btn-warning btn-sm text-light" href="/${CULTURE_EMPREGARE}/candidato/matricula?ReturnUrl=${window.location.href}">${i18next.t('AlunoVincularMatricula')}</a>
                    </div>`;
                return;
            case "Erro":
                $containerInscrevase.innerHTML = `<div class="alert alert-danger mb-0">
                        <h5>${i18next.t('ErroCandidatarVagaTitulo')}</h5>
                        <p class="mb-1">${i18next.t('ErroCandidatarVagaTexto')}</p>
                        <a href="#" onclick="window.location.reload();" class="btn btn-danger text-light">${i18next.t('ErroCandidatarVagaRecarregar')}</a>
                    </div>`;

                addTrack('Erro Vaga', { vagaID: vagaID });
                return;
            default:
                return;
        }
    };
    const _botaoCandidatar = async function () {
        $containerInscrevaseStick.innerHTML = '';
        document.getElementById('navbarFixadaDetalheVaga').classList.add('d-none');
        const callbackSucesso = (resultado) => {
            _montaBotaoCandidatar(resultado);
            if (resultado.retorno != 'VagaEncerrada' && resultado.retorno != 'Inscrito') {
                _insights(resultado.pessoaID);
            }
        }
        const callbackErro = () => {
            $containerInscrevase.innerHTML = `<div class="alert alert-danger mb-0">
                        <h5>${i18next.t('ErroCandidatarVagaTitulo')}</h5>
                        <p class="mt-3">${i18next.t('ErroCandidatarVagaTexto')}</p>
                        <a href="#" onclick="window.location.reload();" class="btn btn-danger text-light"><i class="bi bi-arrow-clockwise"></i> ${i18next.t('ErroCandidatarVagaRecarregar')}</a>
                    </div>`;
        }

        await getFetch(`/${CULTURE_EMPREGARE}/Vagas/BotaoCandidatar/${vagaID}`, callbackSucesso, callbackErro, callbackErro);
    };

    const _definirOrigemCadastro = async function () {
        let source = '';

        source = obterQueryString().campanha;
        if (isNullOrEmpty(source)) {
            source = obterQueryString().source;
        }
        if (isNullOrEmpty(source)) {
            return;
        }
        salvarCookie('origemCadastro', source, 1);
    };

    const _stickyTopScrollDetalhesVaga = (containerInscrevase, containerInscrevaseStick, eventListner) => {
        const navbarFixadaDetalheVaga = document.getElementById('navbarFixadaDetalheVaga');

        const observer = new window.IntersectionObserver((e) => {
            console.log(e);
            if (!e[0].isIntersecting) {
                navbarFixadaDetalheVaga.classList.remove('d-none');
                //console.log('exibe');
            } else {
                navbarFixadaDetalheVaga.classList.add('d-none');
                //console.log('oculta');
            }
        });

        //Se parar de ver o card com os detalhes da vaga, exibe stick top
        observer.observe(document.querySelector('.btn-candidatarse'));

        containerInscrevaseStick.innerHTML = containerInscrevase.innerHTML;
        const btn = containerInscrevaseStick.querySelector('button');
        if (btn) {
            btn.classList.add('ajuste-nav-info-vaga-btn-inscrever');
            //btn.classList.remove('btn-lg');
            if (eventListner == 'NaoLogado') {
                btn.addEventListener('click', (e) => {
                    addTrack('Inscricao Vaga', { finalizouCandidatura: false, vagaID: vagaID });
                    salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, false);
                    document.querySelector('.btn-login').click();
                });
            } else {
                if (variasCidades) {
                    btn.addEventListener('click', async (e) => {
                        await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
                        addTrack('Inscricao Vaga', { finalizouCandidatura: false, vagaID: vagaID });
                    });

                } else {
                    btn.addEventListener('click', async (e) => {
                        _confirmarCandidatura();
                    });
                }
            }
        }
    };

    const _atualizarContainerAlerta = evento => {
        const wrapper = document.getElementById('botao-wrapper-alerta');
        if (evento.type == 'alerta-excluido') {
            wrapper.querySelector('h5 b').textContent = i18next.t('AlertaVagasConfigurarAlertaText');
        } else if (evento.type == 'alerta-salvo') {
            wrapper.querySelector('h5 b').textContent = i18next.t('AlertaVagasEditarText');
        }
    }

    const criarBlocoAlertaVagas = async () => {
        const url = `/${CULTURE_EMPREGARE}/Vagas/VerificarAlertaVagas/?vagaCargo=${vagaCargo}`;
        const callbackSucesso = (data) => {
            // const ehUmHotsite = data.data.hotsite != null;
            // const hotsiteTipoExpress = 3;
            // const ehUmHotsiteExpress = ehUmHotsite && (data.data.hotsite != null && data.data.hotsite?.Tipo == hotsiteTipoExpress);
            const vagaDetalhesContainer = document.querySelector("#vaga-detalhes-container");
            const blocoInformacoes = vagaDetalhesContainer?.querySelector(".informacoes");
            const blocoAlertaVagas = blocoInformacoes?.querySelector(".container-alerta-vagas");
            const cardAlertaVagas = blocoAlertaVagas?.querySelector(".card-alerta-vagas");

            if(!isNullOrEmpty(vagaCargo)){
                if(cardAlertaVagas){
                    cardAlertaVagas.innerHTML = templateCardAlertaVagas(data.data, vagaCargo, vagaID, vagaCidadesSeparadas, vagaCidadesSeparadasVirgula);

                   

                    const botao = document.getElementById('botao-alerta');
                    if (botao) {
                        new AlertaVaga(botao);
            
                        const wrapperAlerta = document.getElementById('botao-wrapper-alerta');
                        wrapperAlerta.addEventListener('alerta-salvo', _atualizarContainerAlerta);
                        wrapperAlerta.addEventListener('alerta-excluido', _atualizarContainerAlerta);
                    }
                }
            }
            else
                blocoAlertaVagas.classList.add('d-none');
        };

        await getFetch(url, callbackSucesso);
    };

    const init = function () {
        banner.renderizar('banner-detalhes-vaga', localBanner.VAGA_DETALHES);

        inicializarInternacionalizacao();

        Confirm.init({
            className: "confirm-empregare",
            titleColor: "#EA1F1F",
            okButtonColor: "#f8f8f8",
            okButtonBackground: "#EA1F1F",
            cancelButtonColor: "#f8f8f8",
        });
        _definirOrigemCadastro();
        const btnModalCompartilhar = document.querySelectorAll('.btn-abrir-modal-divulgacao');
        btnModalCompartilhar.forEach(el => el.addEventListener('click', () => {
            _modalCompartilhar();
        }));
        _modalCompartilharCopiarLink();

        document.querySelectorAll('.info-cega').forEach(el => el.addEventListener('click', () => {
            const tabParaAbrir = el.dataset.tab;
            _modalSelecaoCega(tabParaAbrir);
        }));

        document.getElementById('btn-login-vaga').addEventListener('click', () => {
            _modalCandidatarLogin();
        });
        document.getElementById('btn-cadastrar-vaga').addEventListener('click', () => {
            _redirecionarNovoCadastro();
        });
        document.getElementById('form-confirmar-inscricao').addEventListener('submit', (e) => {
            _confirmarCandidatura();
            e.preventDefault();
        });
        _botaoCandidatar();
        criarBlocoAlertaVagas();

        //const btnLogin = document.querySelector('.btn-login').classList;
        //btnLogin.add('btn-primary');
        //btnLogin.remove('btn-outline-primary');


    };

    return init();
};

// i18next.on('initialized', vagaDetalhes)
vagaDetalhes();